<template>
    <div class="videocard">
        <a
            class="img"
            :href="isPublic?`/HealthEducation/HealthVideo?Id=${data.Id}`:`/Conference/DigitalVideo?Id=${data.Id}`"
        >
            <img :src="data.Image" />
            <div class="play">
                <div>▶</div>
            </div>
        </a>
        <!-- <div class="date">{{data.Date}}</div> -->
        <div class="title">{{data.Title}}</div>
        <div class="content" v-if="!isIndex">{{data.Introduction}}</div>
    </div>
</template>

<script>
export default {
    name: "videocard",
    components: {},
    props: {
        data: {
            type: Object
        },
        isPublic: {
            type: Boolean
        },
        isIndex: {
            type: Boolean
        }
    },
    data() {
        return {};
    },
    methods: {},
    computed: {},
    created() {},
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.videocard {
    letter-spacing: 2px;
    line-height: 1.5;
}
.videocard .img {
    border: 4px solid #a59b92;
    font-size: 0;
    position: relative;
    display: block;
}
.videocard .img:hover .play {
    opacity: 1;
}
.videocard .img img {
    width: 100%;
}
.videocard .img .play {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    opacity: 0;
}
.videocard .img .play > div {
    background-color: #fff;
    font-size: 18px;
    padding: 12px 15px;
    border-radius: 50px;
    color: #666;
}
.videocard .date {
    color: #666;
    padding: 10px 0;
}
.videocard .title {
    font-size: 1.2rem;
    padding: 10px;
    min-height: 66px;
}
.videocard .content {
    color: #666;
    padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/information/videoCard.vue